import { render, staticRenderFns } from "./job.vue?vue&type=template&id=5542d296&scoped=true&"
import script from "./job.vue?vue&type=script&lang=js&"
export * from "./job.vue?vue&type=script&lang=js&"
import style0 from "./job.vue?vue&type=style&index=0&id=5542d296&scoped=true&lang=less&"
import style1 from "./job.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5542d296",
  null
  
)

export default component.exports